<template lang="pug">
BriqTable
  thead
    th Date & time
    th Object type
    th Change type
    th User
    th Description
    th 
  tbody
    template(v-for="item in logData")
      tr.audit-trail-data-col(@click="item.showDetals = !item.showDetals")
        td {{ prettyDate(item.InsertDatetimeUtc) }}
        td {{ item.Category }}
        td {{ item.ChangeType }}
        td {{ item.UserFullName }}
        td {{ item.Message }}
        td 
          .show-detals-btn(:class="item.showDetals ? `rotate-180` : ``")
            BriqIcon(name="icon-input-arrow-down-icon")
      tr(v-if="item.showDetals")
        td(colspan="6") 
          .logs-details-table
            BriqTable
              thead
                th Property
                th Old value
                th New value
              tbody
                tr(v-for="itemDetails in item.Values")
                  td {{ itemDetails.PropertyName }}
                  td {{ itemDetails.OldValue }}
                  td {{ itemDetails.NewValue }}
</template>

<script>
import logTablesMixin from './logTablesMixin.js'

export default {
  name: 'AuditTrailTable',
  mixins: [logTablesMixin],
  props: {
    logData: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/components-global/BriqViewAuditTrail/tableStyle.styl'
</style>
